module.exports = __webpack_public_path__ + "static/assets/ed7d8e65417a8a01c5f810e4abc1c6e9.svg";